import { render } from "./DescriptionText.vue?vue&type=template&id=13e02a8d&scoped=true"
import script from "./DescriptionText.vue?vue&type=script&lang=js"
export * from "./DescriptionText.vue?vue&type=script&lang=js"

import "./DescriptionText.vue?vue&type=style&index=0&id=13e02a8d&scoped=true&lang=css"

import exportComponent from "/Users/gabrielvoirol/git_projects/df_wpheadless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e02a8d"]])

export default __exports__